import { ChangeDetectionStrategy, Component, inject, ViewEncapsulation } from '@angular/core';
import {
    ApiTypes,
    DealerFeature,
    DistributionFeature,
    isHWS,
    RouterLinkDirective,
    VehicleFeature,
} from '@hyundai/ng-common-lib';
import { M000C010ImageComponent, M000C040LoadingSpinnerComponent } from '@hyundai/ui';
import { Store } from '@ngrx/store';
import { CHECKOUT_STEP_TOKEN, CheckoutStepComponent } from '@pixelgenau/ngx-checkouts';

@Component({
    selector: 'lib-distribution-thanks-step',
    standalone: true,
    templateUrl: './distribution-thanks-step.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [M000C010ImageComponent, RouterLinkDirective, M000C040LoadingSpinnerComponent],
    providers: [{ provide: CHECKOUT_STEP_TOKEN, useExisting: DistributionThanksStepComponent }],
})
export default class DistributionThanksStepComponent extends CheckoutStepComponent {
    store = inject(Store);
    vehicle = this.store.selectSignal(VehicleFeature.vehicleState.selectLoadedDetail);
    success = this.store.selectSignal(DistributionFeature.distributionState.selectSubmitFormSuccess);
    loading = this.store.selectSignal(DistributionFeature.distributionState.selectSubmitFormLoading);
    dealerName = isHWS() ? this.store.selectSignal(DealerFeature.state.selectDealerName) : undefined;

    override showStepperMenu(): boolean {
        return false;
    }

    override showSidebar(): boolean {
        return false;
    }

    override activate(): void {
        const data = this.submitData() as unknown as
            | ApiTypes.TestDriveFormPayload
            | ApiTypes.GeneralRequestFormPayload
            | ApiTypes.ReservationFormPayload;

        data.vehicle = this.vehicle().slug;
        if (Object.prototype.hasOwnProperty.call(data, 'wishTime')) {
            this.store.dispatch(
                DistributionFeature.actions.submitTestDriveForm({
                    payload: data as ApiTypes.TestDriveFormPayload,
                    vehicle: this.vehicle(),
                }),
            );
        } else if (Object.prototype.hasOwnProperty.call(data, 'message')) {
            this.store.dispatch(
                DistributionFeature.actions.submitGeneralRequestForm({
                    payload: data as ApiTypes.GeneralRequestFormPayload,
                    vehicle: this.vehicle(),
                }),
            );
        } else {
            this.store.dispatch(
                DistributionFeature.actions.submitReservationForm({
                    payload: data as ApiTypes.ReservationFormPayload,
                    vehicle: this.vehicle(),
                }),
            );
        }
        super.activate();
    }
}
